<ng-container *ngIf="(isLoading$ | async) === false">
    <div class="mb-4 bg-white shadow-md"></div>
    <div class="content overflow-y-auto bg-white p-4 shadow-md">
        <p
            class="mb-2 text-sm font-semibold leading-5 tracking-wider text-grey-dark dark:text-contrast-yellow"
            [class.uppercase]="!env.REMOVE_UPPERCASE">
            {{ 'TICKET_TYPE' | translate }}
        </p>
        <div
            class="border-t border-solid border-black border-opacity-10"
            *ngFor="let productTravellerType of productTravellerTypes">
            <div
                class="flex flex-col gap-1 py-4"
                [attr.aria-label]="productTravellerType?.ariaLabel"
                role="group"
                tabindex="0">
                <div class="flex justify-between gap-2" aria-hidden="true">
                    <p class="text-base font-bold leading-5">
                        {{ productTravellerType.name | translateObjectField: null : currentLanguage }}
                    </p>
                    <div
                        class="whitespace-nowrap text-base leading-5"
                        [ngClass]="{
                            'font-bold': productTravellerType.amount > 0,
                            'font-medium': !(productTravellerType.amount > 0)
                        }">
                        {{
                            productTravellerType.price.amount || productTravellerType.price?.maxAmount || 0
                                | moneyFormat
                        }}
                        {{ env.CURRENCY || productTravellerType?.price?.currency || currency }}
                    </div>
                </div>
                <p class="text-base font-normal leading-5" aria-hidden="true">
                    {{ getProductDescription(productTravellerType) }}
                </p>
            </div>
            <div class="flex justify-end pb-4">
                <div class="flex">
                    <ion-button
                        class="orb-app-light:bg-primary tartu-light:bg-[var(--btn-primary-color)] vl-app-light:bg-[var(--btn-primary-color)] content-product__amount_remove left amount m-0 h-14 w-14 bg-secondary dark:bg-contrast-yellow"
                        [attr.aria-label]="'ACTION_DELETE_TITLE' | translate"
                        [disabled]="productTravellerType?.amount === 0"
                        (click)="removeAmount(productTravellerType?.id)"
                        color="none">
                        <ion-icon
                            class="orb-app-light:text-black var-app-light:text-black vl-app-light:text-black text-white dark:text-contrast-black"
                            [ngClass]="{
                                'var-app-light:text-black orb-app-light:text-black': productTravellerType.amount > 0,
                                'var-app-light:text-black/50 orb-app-light:text-black/50':
                                    productTravellerType?.amount === 0
                            }"
                            name="remove"></ion-icon>
                    </ion-button>
                    <div
                        class="content-product__amount flex h-14 w-12 items-center justify-center bg-grey-white_smoke text-base font-bold leading-5 dark:bg-contrast-black">
                        {{ productTravellerType?.amount }}
                    </div>
                    <ion-button
                        class="orb-app-light:bg-primary tartu-light:bg-[var(--btn-primary-color)] vl-app-light:bg-[var(--btn-primary-color)] content-product__amount_add right amount m-0 h-14 w-14 bg-secondary dark:bg-contrast-yellow"
                        [attr.aria-label]="'ADD' | translate"
                        [disabled]="(isAddButtonDisabledForType$ | async)?.[productTravellerType?.id]"
                        (click)="addAmount(productTravellerType?.id)"
                        color="none">
                        <ion-icon
                            class="orb-app-light:text-black vl-app-light:text-black var-app-light:text-black text-white dark:text-contrast-black"
                            name="add"></ion-icon>
                    </ion-button>
                </div>
            </div>
        </div>
    </div>
</ng-container>
